import { render, staticRenderFns } from "./clinic-state-form.vue?vue&type=template&id=e47b2c7a&scoped=true&lang=pug&"
import script from "./clinic-state-form.vue?vue&type=script&lang=ts&"
export * from "./clinic-state-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e47b2c7a",
  null
  
)

export default component.exports